import { Timestamp } from "firebase/firestore";
import { Widget } from "./widget.model";

export class Dashboard {
    id?:string;
    created_at?: Timestamp;
    owner_id?: string;
    widgets: Array<Widget> = []
}
